import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { OFFER_SERVER_URL } from '../../config';
import { FastLaneRequest } from '../models/fastlane.model';

const OFFER_SERVER_URL_V1 = `${ OFFER_SERVER_URL }/v1/fastlaneRequests`;

@Injectable({ providedIn: 'root' })
export class FastlaneAPIService {
	constructor(
		private readonly http: HttpClient,
	) {}

	submitOrder(order: FastLaneRequest): Observable <FastLaneRequest> {
		const url = new URL(OFFER_SERVER_URL_V1);
		return this.http.post<FastLaneRequest>(
			url.toString(),
			order
		);
	}
}
